"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var plugin_exports = {};
__export(plugin_exports, {
  default: () => plugin_default,
  loveId: () => loveId,
  roomAccessIcon: () => roomAccessIcon,
  roomAccessLabel: () => roomAccessLabel
});
module.exports = __toCommonJS(plugin_exports);
var import_platform = require("@hcengineering/platform");
var import_types2 = require("./types");
const loveId = "love";
const love = (0, import_platform.plugin)(loveId, {
  class: {
    Room: "",
    Floor: "",
    Office: "",
    ParticipantInfo: "",
    PendingRecording: "",
    DevicesPreference: "",
    RoomInfo: "",
    MeetingMinutes: "",
    UserMeetingInvite: ""
  },
  mixin: {
    MeetingEventLink: "",
    MeetingSchedule: ""
  },
  action: {
    ToggleMic: "",
    ToggleVideo: ""
  },
  string: {
    Office: "",
    MyOffice: "",
    Room: "",
    IsKnocking: "",
    KnockingLabel: "",
    InvitingYou: "",
    MeetingRequest: "",
    Kind: "",
    RoomType: "",
    Knock: "",
    Open: "",
    DND: "",
    StartTranscription: "",
    StopTranscription: "",
    Meeting: "",
    Transcription: "",
    TranscriptionState: "",
    TranscriptionNotStarted: "",
    TranscriptionTranscribing: "",
    TranscriptionFinished: "",
    StartWithTranscription: "",
    // Guest join labels
    GuestFirstName: "",
    GuestLastName: "",
    // Start-with toggles for guest join
    StartWithVideo: "",
    StartWithAudio: "",
    MeetingMinutes: "",
    MeetingsMinutes: "",
    StartMeeting: "",
    Video: "",
    NoMeetingMinutes: "",
    JoinMeeting: "",
    JoinedMeeting: "",
    Accept: "",
    Decline: "",
    Join: "",
    Reject: "",
    MeetingStart: "",
    MeetingEnd: "",
    Status: "",
    Active: "",
    Finished: "",
    Pending: "",
    StartWithRecording: "",
    RecordingState: "",
    RecordingNotStarted: "",
    RecordingRecording: "",
    RecordingFinished: "",
    Recording: "",
    StoppingRecord: "",
    Kick: "",
    EndMeeting: "",
    SearchMeetingMinutes: "",
    FinishMeeting: "",
    AddParticipant: "",
    LeaveParticipant: "",
    KnockAction: "",
    KnockingTo: "",
    ShowParticipants: "",
    HideParticipants: "",
    Scheduled: "",
    ScheduledIn: "",
    WaitForHost: ""
  },
  ids: {
    MainFloor: "",
    Reception: "",
    InviteNotification: "",
    KnockNotification: "",
    LoveWidget: "",
    MeetingWidget: "",
    LoveNotificationGroup: ""
  },
  icon: {
    Love: "",
    LeaveRoom: "",
    EnterRoom: "",
    Mic: "",
    MicEnabled: "",
    MicDisabled: "",
    Cam: "",
    CamEnabled: "",
    CamDisabled: "",
    SharingEnabled: "",
    SharingDisabled: "",
    Open: "",
    Knock: "",
    DND: "",
    Record: "",
    StopRecord: "",
    FullScreen: "",
    ExitFullScreen: "",
    Invite: "",
    Kick: "",
    MeetingMinutes: ""
  },
  sound: {
    Knock: "",
    MeetingEndNotification: ""
  },
  metadata: {
    WebSocketURL: "",
    ServiceEndpoint: ""
  },
  space: {
    Drive: ""
  },
  component: {
    SelectScreenSourcePopup: "",
    GuestMeetingApp: ""
  },
  viewlet: {
    TableMeetingMinutes: "",
    TableMeetingMinutesEmbedded: "",
    MeetingMinutesDescriptor: "",
    FloorDescriptor: "",
    Floor: "",
    FloorMeetingMinutes: ""
  }
});
const roomAccessIcon = {
  [import_types2.RoomAccess.Open]: love.icon.Open,
  [import_types2.RoomAccess.Knock]: love.icon.Knock,
  [import_types2.RoomAccess.DND]: love.icon.DND
};
const roomAccessLabel = {
  [import_types2.RoomAccess.Open]: love.string.Open,
  [import_types2.RoomAccess.Knock]: love.string.Knock,
  [import_types2.RoomAccess.DND]: love.string.DND
};
var plugin_default = love;
//# sourceMappingURL=plugin.js.map
